import { IDeleteOptions, TDefinitionKey, TJsonQueryValue } from './definitionFactory';
import { IThunkActionCreator } from '../../types/thunk';
import { clearJsonQueryAction } from '../filters';
import { getOffersData } from '../offersData';
import { putDefaultRegion, updateTags } from './tags';

export function onDeleteAction(
  value: TJsonQueryValue,
  key: TDefinitionKey,
  options: IDeleteOptions,
): IThunkActionCreator {
  return dispatch => {
    dispatch(clearJsonQueryAction(key, value));
    dispatch(updateTags());
    dispatch(putDefaultRegion());
    if (!options.skipUpdateOffersCount) {
      dispatch(getOffersData({ reason: 'delete_filter_tag' }));
    }
  };
}
